import NavigationCard, {
  TNavigationCardProps as TNavigationCard,
} from "../../elements/navigation-card/navigation-card";
import styles from "./navigation-card-list-block.module.less";

export type TNavigationCardListBlockProps = {
  items: Array<TNavigationCard>;
};

export const NavigationCardListBlock = ({ items }: TNavigationCardListBlockProps) => {
  return (
    <section className={[styles.wrapper, "max-width padded-sides"].join(" ")}>
      <ul className={styles.list}>
        {items.map((item, index) => (
          <li key={index} className={styles.item}>
            <NavigationCard {...item} />
          </li>
        ))}
      </ul>
    </section>
  );
};

export default NavigationCardListBlock;
